export default __webpack_public_path__ + "static/media/1-and-2-capture.9e43c184.gif";